import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import { Auth0Provider } from '@auth0/auth0-react';


const domain="empowher-metrohacks.us.auth0.com";
const clientId="6RYHYAfnlah4mGgi3kgAnfFCUAHX1QZL";


ReactDOM.render(
  <Auth0Provider
      domain = "empowher-metrohacks.us.auth0.com"
      clientId="6RYHYAfnlah4mGgi3kgAnfFCUAHX1QZL"
      redirectUri = {window.location.origin}
      >
      

    <App />
  </Auth0Provider>,
  document.getElementById('root')
);

